import * as yup from 'yup';

import { commonValidationSchema } from '@olo-web/utils/common/validationSchema';

export const validationSchema = yup.object().shape({
  firstName: commonValidationSchema.firstName,
  lastName: commonValidationSchema.lastName,
  email: commonValidationSchema.email,
  password: commonValidationSchema.password,
  phone: commonValidationSchema.phone,
  confirmPassword: commonValidationSchema.confirmPassword,
});
